import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

export const deleteComment = async (data: number) => {
  return axios.delete(`${endpoints.removeComment}?id=${data}`)
}

export const useDeleteComment = () => {
  const client = useQueryClient()

  return useMutation(deleteComment, {
    onSuccess: () => {
      client.invalidateQueries([ApiKey.comment, ApiKey.message])
    },
  })
}
